var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2012_15630)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "url(#paint0_linear_2012_15630)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2012_15630)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.9699,
    transform: "matrix(-1 0 0 1 24.937 -5.9375)",
    fill: "#292C39"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 18.7,
    height: 18.7,
    rx: 3.35,
    stroke: "url(#paint1_linear_2012_15630)",
    strokeOpacity: 0.5,
    strokeWidth: 1.3,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17679 6.77169C6.51673 5.7755 7.35323 4.75 8.59092 4.75H11.4093C12.6474 4.75 13.483 5.7755 13.8234 6.77169C14.099 7.57888 14.5737 7.93369 14.96 8.09906C15.1245 8.1695 15.2979 8.21662 15.4754 8.23906C15.5368 8.24675 15.5986 8.2507 15.6605 8.25087H15.6649C15.7663 8.24575 15.8663 8.27607 15.9479 8.33665C16.0294 8.39722 16.0873 8.48427 16.1117 8.58286C16.136 8.68146 16.1253 8.78546 16.0814 8.87703C16.0375 8.9686 15.9631 9.04204 15.8709 9.08475H15.87L15.8696 9.08562L15.867 9.0865L15.8604 9.08956C15.7338 9.14333 15.6054 9.19279 15.4754 9.23788C15.2239 9.3245 14.8537 9.43825 14.3642 9.55112C13.3846 9.77731 11.9295 10 10.0001 10C8.69373 10 7.23948 9.77512 6.12385 9.55419C5.5263 9.43573 4.93223 9.30034 4.34235 9.14819L4.23473 9.11975L4.20629 9.11188L4.19885 9.11012L4.19623 9.10925C4.09176 9.0811 4.00143 9.01524 3.94268 8.92439C3.88393 8.83354 3.86093 8.72414 3.87812 8.61732C3.8953 8.5105 3.95146 8.41384 4.03574 8.346C4.12003 8.27816 4.22646 8.24396 4.33448 8.25H4.37429C4.42462 8.2487 4.47484 8.2449 4.52479 8.23862C4.70226 8.21619 4.87573 8.16906 5.04017 8.09863C5.42604 7.93325 5.90117 7.57844 6.17679 6.77125V6.77169Z",
    fill: "#9598A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.375 11.7502C7.0269 11.7502 6.69306 11.8885 6.44692 12.1346C6.20078 12.3808 6.0625 12.7146 6.0625 13.0627C6.0625 13.4108 6.20078 13.7447 6.44692 13.9908C6.69306 14.2369 7.0269 14.3752 7.375 14.3752C7.7231 14.3752 8.05694 14.2369 8.30308 13.9908C8.54922 13.7447 8.6875 13.4108 8.6875 13.0627C8.6875 12.7146 8.54922 12.3808 8.30308 12.1346C8.05694 11.8885 7.7231 11.7502 7.375 11.7502ZM5.1875 13.0627C5.18696 12.5201 5.38815 11.9966 5.75199 11.5939C6.11582 11.1913 6.61632 10.9383 7.15627 10.884C7.69622 10.8298 8.23706 10.9781 8.67373 11.3003C9.11041 11.6225 9.41174 12.0955 9.51919 12.6274C9.53363 12.6261 9.54806 12.6252 9.5625 12.6252H10.4375C10.4519 12.6252 10.4668 12.6261 10.4808 12.6274C10.5901 12.0972 10.8921 11.6262 11.3284 11.3057C11.7646 10.9851 12.3043 10.8376 12.843 10.8918C13.3816 10.9459 13.8811 11.1978 14.2449 11.5988C14.6087 11.9997 14.8109 12.5213 14.8125 13.0627C14.813 13.6054 14.6119 14.1289 14.248 14.5315C13.8842 14.9341 13.3837 15.1872 12.8437 15.2414C12.3038 15.2957 11.7629 15.1473 11.3263 14.8251C10.8896 14.503 10.5883 14.03 10.4808 13.498C10.4664 13.4995 10.452 13.5002 10.4375 13.5002H9.5625C9.54806 13.5002 9.53363 13.4993 9.51919 13.498C9.4099 14.0283 9.10793 14.4992 8.67165 14.8198C8.23536 15.1403 7.69573 15.2878 7.15705 15.2337C6.61836 15.1795 6.11887 14.9276 5.7551 14.5267C5.39132 14.1257 5.1891 13.6041 5.1875 13.0627ZM12.625 11.7502C12.2769 11.7502 11.9431 11.8885 11.6969 12.1346C11.4508 12.3808 11.3125 12.7146 11.3125 13.0627C11.3125 13.4108 11.4508 13.7447 11.6969 13.9908C11.9431 14.2369 12.2769 14.3752 12.625 14.3752C12.9731 14.3752 13.3069 14.2369 13.5531 13.9908C13.7992 13.7447 13.9375 13.4108 13.9375 13.0627C13.9375 12.7146 13.7992 12.3808 13.5531 12.1346C13.3069 11.8885 12.9731 11.7502 12.625 11.7502Z",
    fill: "#9598A7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2012_15630",
    x1: 4.15385,
    y1: 2,
    x2: 15.0769,
    y2: 18.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFBBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A8C9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2012_15630",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2012_15630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2012_15630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "matrix(-1 0 0 1 25 -6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateIcon);
export default __webpack_public_path__ + "static/media/private-icon.8561e367fbb66642887d407888bb7bbb.svg";
export { ForwardRef as ReactComponent };